/* typescript-eslnt-disable import/no-useless-path-segments */
/* eslint-disable*/
import axios, { Axios, AxiosRequestHeaders, AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import { doRefreshToken, alerts } from '../utils';

const URL_API = process.env.REACT_APP_URL_API;
const BASE_API = process.env.REACT_APP_BASE_API;

const header = () => {
  const token = localStorage.getItem('token');
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
    'Referrer': 'no-referrer-when-downgrade',
    Authorization: `Bearer ${token}`,
  };
};

const getHeaders = (): AxiosRequestHeaders => header();

export const xhr = axios.create({
  baseURL: URL_API,
  headers: getHeaders(),
  timeout: 0,
});

export const setTokenAfterLogin = async (token: string): Promise<Axios> => {
  //  Aparentemente essa função retem o ultimo token válido
  localStorage.setItem('token', token);
  xhr.interceptors.request.use(
    async (config: AxiosRequestConfig) => ({
      ...config,
      headers: header(),
    }),
    (error) => Promise.reject(error),
  );
  return xhr;
};

export const deleteTokenAfterFail = async (token: string): Promise<Axios> => {
  localStorage.setItem('token', token);
  return xhr;
};

xhr.interceptors.response.use((response) => response, (error) => {
  if (error.response.status === 401) {
    if (error.response.data.paramsResetPassword) {
      const changePasswordUrl = error.response.data.paramsResetPassword.message
        ? error.response.data.paramsResetPassword.message
        : BASE_API;

      window.location.href = changePasswordUrl;
    }
  }

  return Promise.reject(error);
});

export default xhr;
